module.exports = __webpack_public_path__ + "static/media/2.1db1c74a.png";